import FieldState from './FieldState';
import ArrayFieldState from './ArrayFieldState';
import FlatArrayFieldState from './FlatArrayFieldState';

export default function buildFieldState(form, fieldName, fieldConfig) {
  let fieldState = null;

  if (!fieldName.includes('[].')) {
    const finalConfig = {
      ...fieldConfig,
      originalName: fieldConfig.name,
      name: fieldName,
      readOnly: form.options.readOnly === true
    };

    if (fieldConfig.isComplexArray) {
      // Array that will contain complex things
      fieldState = new ArrayFieldState(form, finalConfig);
    } else if (fieldName.endsWith('[]')) {
      // Simple Array
      finalConfig.name = fieldName.slice(0, -2);
      fieldState = new FlatArrayFieldState(form, finalConfig);
    } else {
      // Simple Field
      fieldState = new FieldState(form, finalConfig);
    }
  }

  return fieldState;
}
